import { css } from "@emotion/css";
// import { getDevice, mobile, tablet } from "../../../../../data/bp";
// import { decodeAttribute } from "../../../../../parser/parserResponsive";
// import { decodeStyle } from "../../../../../parser/styleparser";
import {
    decodeStyle,
    decodeAttribute,
    getDevice,
    mobile,
    tablet,
} from "../../../../juntion";
import styles from "./styles/SectionWrapper.module.scss";
import BackgroundSlider from "../BackgroundSlider";

function SectionWrapper({
    children,
    data,
    index,
    input,
    ps,
    gs,
    device,
    isHeaderSection,
    fixedOnTop,
}) {
    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    const deviceName = getDevice(device);
    let deviceHeight = 720;
    let height = {};
    if (deviceName === "mobile") {
        if ("minHeight" in mobileStyle) {
            height =
                mobileStyle.minHeight.type === "fullscreen"
                    ? {
                          minHeight:
                              mobileStyle.minHeight.params *
                              deviceHeight *
                              0.01,
                      }
                    : {};
        } else if ("minHeight" in tabletStyle) {
            height =
                tabletStyle.minHeight.type === "fullscreen"
                    ? {
                          minHeight:
                              tabletStyle.minHeight.params *
                              deviceHeight *
                              0.01,
                      }
                    : {};
        } else {
            height =
                ps.style.minHeight.type === "fullscreen"
                    ? {
                          minHeight:
                              ps.style.minHeight.params * deviceHeight * 0.01,
                      }
                    : {};
        }
    } else if (deviceName === "tablet") {
        deviceHeight = 900;
        if ("minHeight" in tabletStyle) {
            height =
                tabletStyle.minHeight.type === "fullscreen"
                    ? {
                          minHeight:
                              tabletStyle.minHeight.params *
                              deviceHeight *
                              0.01,
                      }
                    : {};
        } else {
            height =
                ps.style.minHeight.type === "fullscreen"
                    ? {
                          minHeight:
                              ps.style.minHeight.params * deviceHeight * 0.01,
                      }
                    : {};
        }
    }

    const decoded_styles = decodeStyle(ps.style, gs);

    return (
        <div
            // id={data.id}
            id={input.name}
            // className={styles.wrapper}
            className={decoded_styles.backgroundPanning}
            style={{
                display: "flex",
                position: "relative",
                ...decodeStyle(ps.fixStyle, gs),
                ...decoded_styles,
                ...(tablet(device) && decodeStyle(tabletStyle, gs)),
                ...(mobile(device) && decodeStyle(mobileStyle, gs)),
                zIndex: data.input.zIndex,
                backgroundSize: "cover",
                objectFit: "cover",
                backgroundRepeat: "no-repeat",
                backdropFilter: decoded_styles.backgroundFilter,
                // backgroundPosition: "bottom center",
                ...height,
                ...(fixedOnTop
                    ? {
                          position: "absolute",
                          top: 0,
                          right: 0,
                          left: 0,
                      }
                    : {}),
                ...(input.sticky?.type === "top" ||
                input.sticky?.type === "bottom"
                    ? {
                          position: "sticky",
                          [input.sticky?.type]: input.sticky.offset,
                      }
                    : {}),
                // position: "relative",
            }}
            // onContextMenu={opneCMenu}
        >
            {decoded_styles.fullScreenBackground && (
                <div
                    className={decoded_styles.backgroundPanning}
                    style={{
                        background: decoded_styles.background,
                        backgroundSize: "cover",
                        objectFit: "cover",
                        backgroundRepeat: "no-repeat",

                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                    }}
                ></div>
            )}
            {ps.style.background.type === "slideshow" && (
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        // bottom: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: "white",
                        height: "100%",
                        ...(decoded_styles.fullScreenBackground
                            ? {
                                  position: "fixed",
                                  top: 0,
                                  left: 0,
                                  width: "100vw",
                                  height: "100vh",
                              }
                            : {}),
                    }}
                >
                    <BackgroundSlider
                        data={ps.style.background.params}
                        style={decoded_styles}
                    />
                </div>
            )}
            <div className={styles.psudo}></div>
            {children}

            {input.shapeDivider?.type !== "none" && (
                <div
                    // css={css`
                    className={css`
                        position: absolute;
                        z-index: 1;
                        ${input.shapeDivider.position === "bottom" &&
                        "bottom: -1px;"}
                        ${input.shapeDivider.position === "top" && "top: -1px;"}
					left: 0;
                        width: 100%;
                        overflow: hidden;
                        line-height: 0;
                        background: transparent;
                        pointer-events: none;
                        svg {
                            position: relative;
                            display: block;
                            width: calc(100% + 1.3px);
                            height: ${input.shapeDivider.height}px;
                            bottom: -1px;
                            ${input.shapeDivider.position === "bottom" &&
                            "transform: rotate(180deg);"}
                        }
                        .shape-fill {
                            fill: ${typeof input.shapeDivider.color === "object"
                                ? decodeAttribute(input.shapeDivider.color, gs)
                                : input.shapeDivider.color};
                        }
                    `}
                >
                    <svg
                        data-name="Layer 1"
                        // xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1200 120"
                        preserveAspectRatio="none"
                    >
                        {/* <path
                        d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
                        class="shape-fill"
                    ></path> */}
                        <path
                            d={input.shapeDivider.path}
                            className="shape-fill"
                        ></path>
                    </svg>
                </div>
            )}
        </div>
    );
}

export default SectionWrapper;
